import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-xxl-12" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = { class: "card-body pt-9 pb-0" }
const _hoisted_4 = { class: "card-body py-3 col-xl-12" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { align: "center" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "row mb-10",
    align: "center"
  }, [
    /*#__PURE__*/_createVNode("div", { class: "col-12" }, [
      /*#__PURE__*/_createVNode("img", { src: "https://images.empoweredconsumerism-static-files.com/products/pgi/pgi.png" })
    ])
  ])
], -1)
const _hoisted_6 = { align: "center" }
const _hoisted_7 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_8 = { align: "center" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_10 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  Balance", -1)
const _hoisted_12 = { class: "row col-xl-12" }
const _hoisted_13 = { class: "col-xl-6" }
const _hoisted_14 = { class: "card-body py-3" }
const _hoisted_15 = /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column mt-5 mb-5" }, [
  /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Claim History ")
], -1)
const _hoisted_16 = { class: "table-responsive" }
const _hoisted_17 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_18 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-100px rounded-start" }, "Date"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "PGI Product"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-100px" }, "Claim Code")
  ])
], -1)
const _hoisted_19 = { class: "text-dark-75 " }
const _hoisted_20 = { class: "text-dark-75 " }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = { class: "font-weight-bolder text-hover-primary mb-1 font-size-lg" }
const _hoisted_23 = { class: "text-muted font-weight-bold d-block" }
const _hoisted_24 = { class: "text-dark-75 " }
const _hoisted_25 = { class: "text-muted font-weight-bold d-block" }
const _hoisted_26 = { class: "col-xl-6" }
const _hoisted_27 = { class: "card-body py-3" }
const _hoisted_28 = { class: "d-flex align-items-center mb-5" }
const _hoisted_29 = { class: "d-flex align-items-center flex-grow-1" }
const _hoisted_30 = { class: "d-flex flex-column" }
const _hoisted_31 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-6 fw-bolder"
}
const _hoisted_32 = { class: "text-gray-400 fw-bold" }
const _hoisted_33 = { class: "mb-5" }
const _hoisted_34 = {
  key: 0,
  align: "right"
}
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "separator mb-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_ECP_EDP_DashboardNavigator = _resolveComponent("ECP_EDP_DashboardNavigator")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 20,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.isLoading || _ctx.isPGITop20Qualified === false]
    ]),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: [_ctx.widgetClasses, "card"]
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_ECP_EDP_DashboardNavigator)
          ])
        ]),
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode("div", _hoisted_10, _toDisplayString(_ctx.numberWithCommas(_ctx.travel_points).replace(".00", "")), 1)
              ]),
              _hoisted_11
            ])
          ])
        ])
      ], 2),
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode("div", {
            class: [_ctx.widgetClasses, "card mt-10 mb-10"]
          }, [
            _createVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode("div", _hoisted_16, [
                _createVNode("table", _hoisted_17, [
                  _hoisted_18,
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.history, (item, index) => {
                      return (_openBlock(), _createBlock("tr", { key: index }, [
                        _createVNode("td", _hoisted_19, "         " + _toDisplayString(_ctx.formatDate(item.dtestp)), 1),
                        _createVNode("td", _hoisted_20, [
                          _createVNode("div", _hoisted_21, [
                            _createVNode("div", null, [
                              _createVNode("a", _hoisted_22, _toDisplayString(item.pgi_desc), 1),
                              _createVNode("span", _hoisted_23, "[" + _toDisplayString(item.pgi_desc_usid) + " / " + _toDisplayString(item.pgi_desc_serialreg) + "]", 1)
                            ])
                          ])
                        ]),
                        _createVNode("td", _hoisted_24, [
                          _createVNode("span", _hoisted_25, _toDisplayString(item.claimCode), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ], 2)
        ]),
        _createVNode("div", _hoisted_26, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pgitop20products, (item, index) => {
            return (_openBlock(), _createBlock("div", {
              key: index,
              class: "row"
            }, [
              _createVNode("div", {
                class: [_ctx.widgetClasses, "card mt-10 mb-10"]
              }, [
                _createVNode("div", _hoisted_27, [
                  _createVNode("div", _hoisted_28, [
                    _createVNode("div", _hoisted_29, [
                      _createVNode("div", _hoisted_30, [
                        _createVNode("a", _hoisted_31, _toDisplayString(item.pgi_desc), 1),
                        _createVNode("span", _hoisted_32, _toDisplayString(item.pgi_points) + " PGI", 1)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_33, [
                    _createVNode("div", {
                      class: "bgi-no-repeat bgi-size-cover rounded min-h-350px mb-5",
                      style: { 'background-position-x':'center','background-image': 'url(' + item.img_filename + ')', 'background-size': 'contain'}
                    }, null, 4),
                    (item.canclaim === 1)
                      ? (_openBlock(), _createBlock("div", _hoisted_34, [
                          _createVNode("a", {
                            class: "btn btn-sm btn-primary btn-color-muted btn-active-light-danger px-4 py-2",
                            onClick: ($event: any) => (_ctx.claimPGI(item.pgi_code))
                          }, " Claim Now ", 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_35
                ])
              ], 2)
            ]))
          }), 128))
        ])
      ])
    ], 512), [
      [_vShow, _ctx.isLoading == false && _ctx.isPGITop20Qualified === true]
    ])
  ], 64))
}